import React from 'react';

// HOC to remove props from a component
// https://github.com/styled-components/styled-components/pull/2093#issuecomment-461510706
const without = <OmitProps extends string>(...omitProps: OmitProps[]) => {
  const omitSingle = (object: Record<string, any> = {}, key: string): Record<string, any> => {
    if (key === null || key === undefined || !(key in object)) return object;
    const { [key]: deleted, ...otherKeys } = object;
    return otherKeys;
  };

  const omit = (object: Record<string, any> = {}, keys: string[]): Record<string, any> => {
    if (!keys) return object;
    if (Array.isArray(keys)) {
      // calling omitMultiple here would result in a second array check
      return keys.reduce((result, key) => {
        if (key in result) {
          return omitSingle(result, key);
        }
        return result;
      }, object);
    }
    return omitSingle(object, keys);
  };
  // HoF
  return <P = {}>(C: React.ComponentType<P>): React.FunctionComponent<Omit<P, OmitProps>> => {
    const WithoutPropsComponent = React.forwardRef<any, any>(({ children, ...props }, ref) => {
      return React.createElement(C, { ...(omit(props, omitProps) as any), ref }, children);
    }) as React.FunctionComponent<Omit<P, OmitProps>>;
    return WithoutPropsComponent;
  };
};

export default without;
